var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.959,
    height: 27.958,
    viewBox: "0 0 27.959 27.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-profile-update-1978806",
    transform: "translate(67.982 25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8764",
    "data-name": "Group 8764",
    transform: "translate(-69 -26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9670",
    "data-name": "Path 9670",
    d: "M21.215,35.444A3.021,3.021,0,0,0,18.2,38.459V41.78a.413.413,0,0,0,.437.437H30.654a.413.413,0,0,0,.437-.437V38.415A3.021,3.021,0,0,0,28.076,35.4H21.215Zm9,2.971v2.928h-11.1V38.415a2.145,2.145,0,0,1,2.141-2.141h6.9A2.157,2.157,0,0,1,30.217,38.415Z",
    transform: "translate(-9.674 -19.368)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9671",
    "data-name": "Path 9671",
    d: "M24.6,18.671A3.671,3.671,0,1,0,28.271,15,3.693,3.693,0,0,0,24.6,18.671Zm6.467,0a2.8,2.8,0,1,1-2.8-2.8A2.788,2.788,0,0,1,31.067,18.671Z",
    transform: "translate(-13.277 -7.882)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9672",
    "data-name": "Path 9672",
    d: "M22.379,3.1l2.753-.524a.423.423,0,0,0,.35-.524.453.453,0,0,0-.524-.35l-3.889.787a.4.4,0,0,0-.262.175.464.464,0,0,0-.044.35L21.548,6.9a.446.446,0,1,0,.874-.175l-.568-2.971a13.174,13.174,0,1,1-7.3-1.879.47.47,0,0,0,.437-.437h0A.438.438,0,0,0,14.557,1a13.973,13.973,0,1,0,7.822,2.1Z",
    transform: "translate(0)",
    fill: "#253845"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateProfileIcon);
export default __webpack_public_path__ + "static/media/update-profile-icon.554c1d11bddf778faee93711a5b9df5b.svg";
export { ForwardRef as ReactComponent };